<skl-dialog-content-ins>
	<skl-dialog-header-ins
		id="numbering-change-unavailable-dialog-header"
		[title]="'scenes.shared.numbering-change-guard.dialog.title' | translate"
		(onClose)="confirm()">
	</skl-dialog-header-ins>

	<ins-content id="numbering-change-unavailable-dialog-message">
		{{ message }}
	</ins-content>

	<ins-footer class="dialog__buttons">
		<skl-button
			id="numbering-change-unavailable-dialog-confirm-button"
			(click)="confirm()">
			{{ 'scenes.shared.numbering-change-guard.dialog.buttons.confirm' | translate }}
		</skl-button>
	</ins-footer>
</skl-dialog-content-ins>